export default __webpack_public_path__ + "static/media/betterplace_logo.8757cb30.svg";